/* eslint-disable @nx/enforce-module-boundaries */
import { analiticaInstance } from 'shared/analitica'

export const analitica = analiticaInstance.eventFactory('Chat', {
  chatEvents: {
    buttonClicked: ({ screen, reference }: { screen: string; reference: 'Botão WhatsApp' | 'Botão Twillio' }) => ({
      label: 'button-clicked',
      metadata: {
        description: 'Usuário visualizou o onboarding de reset de senha. Como propriedade retornar o botão clicado',
        owner: 'Customer Journey - Core',
        product: 'Chat',
        project: 'Stone',
        screen,
        reference
      }
    })
  }
})
